import { render, staticRenderFns } from "./editDelivery.vue?vue&type=template&id=5fa1e00c&scoped=true"
import script from "./editDelivery.vue?vue&type=script&lang=js"
export * from "./editDelivery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa1e00c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\XM\\QD\\yangzhou\\merchant-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fa1e00c')) {
      api.createRecord('5fa1e00c', component.options)
    } else {
      api.reload('5fa1e00c', component.options)
    }
    module.hot.accept("./editDelivery.vue?vue&type=template&id=5fa1e00c&scoped=true", function () {
      api.rerender('5fa1e00c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/components/editDelivery.vue"
export default component.exports